import { j as i } from "../../../../jsx-runtime-p91LotPX.mjs";
import { GrowCheckBox as _ } from "../../../CheckBox/AntCheckBox.js";
import { GrowTree as G } from "../../../Tree/AntTree.js";
import { GrowFlex as U } from "../../../Flex/Flex.js";
import { GrowTypography as H } from "../../../Typography/AntTypography.js";
import { ArrowIcon as K, ArrowRightIcon as L } from "../../../../Icons/Icons.js";
import { l as p } from "../../../../lodash-lyheMOjd.mjs";
import { useState as N, useEffect as R, useMemo as z } from "react";
import { p as A } from "../../../../styled-components.browser.esm-DBaC0ZEI.mjs";
import { T as M } from "../../../../style-B5VBq8yY.mjs";
const W = A(_)``, $ = A(G)`
  &.ant-tree {
    width: 100%;
  }

  .ant-tree-treenode {
    width: 100%;
  }

  .ant-tree-node-content-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
  }

  &.ant-tree .ant-tree-node-content-wrapper:hover,
  .ant-tree .ant-tree-checkbox + span:hover {
    background: none;
  }
`, v = A(M.Text)`
  ${({
  hasSymbol: t
}) => t && `
    &::after {
      content: ' \\2020';
      color: var(--cyan-6);
    }
  `}
`;
function re(t) {
  var k, x, C, y;
  const {
    list: n,
    onChangeCheck: a
  } = t, [h, u] = N(!0);
  function w() {
    if (n != null && n.children) {
      const d = n == null ? void 0 : n.children.map((b) => b.hide).every(Boolean);
      u(!d);
      return;
    }
    u(!n.hide);
  }
  R(w, [n]);
  const f = !!n.pinned || ((x = (k = n.cellRendererParams) == null ? void 0 : k.columnCustom) == null ? void 0 : x.type) === "DEFAULT" || ((y = (C = n.cellRendererParams) == null ? void 0 : C.columnCustom) == null ? void 0 : y.type) === "DEFAULT_NON_SORT";
  return /* @__PURE__ */ i.jsx(U, { align: "center", space: "4", style: {
    width: "100%",
    cursor: "pointer"
  }, children: /* @__PURE__ */ i.jsx(W, { onChange: (d) => {
    a == null || a(d.target.checked), u(d.target.checked);
  }, design: "border-design", disabled: f, checked: f ? !0 : h, style: {
    lineHeight: "1.2",
    width: "100%"
  }, children: /* @__PURE__ */ i.jsx(H.Text, { ellipsis: {
    tooltip: {
      title: n.headerName,
      showArrow: !1,
      placement: "bottomLeft"
    }
  }, style: {
    maxWidth: "200px",
    lineHeight: "1.2"
  }, children: n.headerName }) }) });
}
function le(t) {
  var y, d, b, E;
  const [n, a] = N(), [h, u] = N(t.expandedKeys);
  function w() {
    var r, o;
    const e = t.list;
    return e != null && e.children ? {
      title: e.headerName,
      key: e.groupId,
      children: e == null ? void 0 : e.children.map((c) => {
        var m, s;
        return {
          key: c == null ? void 0 : c.colId,
          title: c.headerName,
          className: (s = (m = c.cellRendererParams) == null ? void 0 : m.columnCustom) != null && s.hasSymbol ? "symbol" : "no-symbol"
        };
      })
    } : {
      title: e.headerName,
      key: e.colId,
      className: (o = (r = e.cellRendererParams) == null ? void 0 : r.columnCustom) != null && o.hasSymbol ? "symbol" : "no-symbol"
    };
  }
  const f = z(w, [t.list]), k = !!t.list.pinned || ((d = (y = t.list.cellRendererParams) == null ? void 0 : y.columnCustom) == null ? void 0 : d.type) === "DEFAULT" || ((E = (b = t.list.cellRendererParams) == null ? void 0 : b.columnCustom) == null ? void 0 : E.type) === "DEFAULT_NON_SORT";
  function x(e) {
    if (e.children) {
      const o = p.find(e.children, {
        className: "symbol"
      });
      return !!(o != null && o.key);
    }
    const r = p.find([e], {
      className: "symbol"
    });
    return !!(r != null && r.key);
  }
  function C() {
    var s, T, g, B, D, j, S;
    const e = t.list;
    if (!(e != null && e.children)) {
      const l = t.list;
      if (l.pinned || ((T = (s = l == null ? void 0 : l.cellRendererParams) == null ? void 0 : s.columnCustom) == null ? void 0 : T.type) === "DEFAULT" || ((B = (g = l == null ? void 0 : l.cellRendererParams) == null ? void 0 : g.columnCustom) == null ? void 0 : B.type) === "DEFAULT_NON_SORT") {
        a([l.colId]);
        return;
      } else if (!l.hide) {
        a([l.colId]);
        return;
      }
      a([]);
      return;
    }
    const r = (j = (D = t.list) == null ? void 0 : D.children) == null ? void 0 : j.filter((l) => {
      var I, P, F, O;
      return ((P = (I = e.cellRendererParams) == null ? void 0 : I.columnCustom) == null ? void 0 : P.type) === "DEFAULT" || ((O = (F = e.cellRendererParams) == null ? void 0 : F.columnCustom) == null ? void 0 : O.type) === "DEFAULT_NON_SORT" ? l : !l.hide;
    }).map((l) => l.colId).filter(Boolean), o = (S = t.list) == null ? void 0 : S.children.length, c = r.length, m = o === c ? [e.groupId, ...r] : [...r];
    a(m);
  }
  return R(C, [t.list]), R(() => {
    u(t.expandedKeys);
  }, [t.expandedKeys]), /* @__PURE__ */ i.jsx($, { checkable: !t.isOverlay, titleRender: (e) => /* @__PURE__ */ i.jsxs(U, { space: "4", children: [
    /* @__PURE__ */ i.jsx(v, { style: {
      maxWidth: "200px",
      lineHeight: "1.2"
    }, ellipsis: {
      tooltip: {
        title: e.title,
        showArrow: !1,
        placement: "bottomLeft"
      }
    }, children: e.title }),
    x(e) ? /* @__PURE__ */ i.jsx(v, { hasSymbol: !0 }) : null
  ] }), expandedKeys: h, switcherIcon: h != null && h.length ? /* @__PURE__ */ i.jsx(K, { color: "var(--gray-8)" }) : /* @__PURE__ */ i.jsx(L, { color: "var(--gray-8)" }), selectable: !1, selectedKeys: n, checkedKeys: n, virtual: !1, treeData: [f], onExpand: (e) => {
    u(e);
  }, onCheck: (e, r) => {
    var o, c, m, s;
    if (a(e), (o = r.node) != null && o.children) {
      const T = (c = r.node) == null ? void 0 : c.children.map((g) => g.key);
      (m = t.onChangeCheckCheckGroup) == null || m.call(t, T, r.checked);
      return;
    }
    (s = t.onChangeCheckCheckGroup) == null || s.call(t, [r.node.key], r.checked);
  }, disabled: k, design: "border-design" });
}
export {
  v as CustomColumnName,
  re as TableSortList,
  le as TableSortListGroup
};
//# sourceMappingURL=ColumnSortList.js.map
